import axios from '@/axios'

const state = {
    envelopeCost: {},
};

const getters = {
    getEnvelopeCost: (state) => state.envelopeCost,
};

const mutations = {
    setEnvelopeCost: (state, envelopeCost) => (state.envelopeCost = envelopeCost),
};

const actions = {
    async loadEnvelopeCost(context) {
        await axios().get(`/getEnvelopeCost`).then(response => {
            context.commit('setEnvelopeCost', response.data)
        })
    },
    async updateEnvelopeCost(context, data) {
        await axios().post(`/updateEnvelopeCost`, {
            id: data.id,
            cost: data.cost,
        }).then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
